var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    zoomAndPan: "magnify",
    viewBox: "0 0 750 749.999995",
    height: 24,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "161de9bf93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 105.609375 230.042969 L 644.109375 230.042969 L 644.109375 519.707031 L 105.609375 519.707031 Z M 105.609375 230.042969 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#161de9bf93)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M 636.558594 275.675781 C 646.882812 264.972656 646.597656 247.914062 635.886719 237.59375 C 625.464844 227.511719 608.875 227.511719 598.453125 237.59375 L 374.859375 461.074219 L 151.265625 237.59375 C 140.558594 227.273438 123.492188 227.558594 113.210938 238.261719 C 103.125 248.679688 103.078125 265.210938 113.164062 275.675781 L 344.933594 507.328125 C 361.472656 523.863281 388.246094 523.863281 404.789062 507.328125 L 636.558594 275.675781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownIconWhite);
export default __webpack_public_path__ + "static/media/dropdown_icon_white.f14513a7c9958bf7c6c5ed4d602f4dce.svg";
export { ForwardRef as ReactComponent };